// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"279":"c3c4362c","787":"6d44df31"}[chunkId] + ".chunk.js";
};